import React, { Fragment, Suspense } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { getConsumerInformation, postSendMessage } from '@actions/individualPortal/ticket/ticketActionCreators';
import TicketSendMessageForm from '../forms/TicketSendMessageForm';


const TicketSendMessageContainer = (oldProps) => {
    let props = { ...oldProps, ticketId: window.localStorage.getItem('ticketId'), encrTicketId: window.localStorage.getItem('encrTicketId'), ticketObj: JSON.parse(window.localStorage.getItem('ticketInfo')) };

    return (
        <Fragment>
            <Suspense fallback={<FormattedMessage id='spinner.loading_data'/>}>
                <TicketSendMessageForm { ...props } />
            </Suspense>
        </Fragment>
    );
};


const mapStateToProps = state => ({
    environment: state.common.environment,
});

export default connect(mapStateToProps, { getConsumerInformation, postSendMessage })(TicketSendMessageContainer);